import React from 'react';
import './IconList.scss';
import ThemeIcon from '../ThemeIcon/ThemeIcon';

const IconList = ({icon, title, description}) => {
    return (
        <div className="feature-card">
            <div className="icon-list">
                <div className="icon-area">
                    <ThemeIcon icon={icon} />
                </div>
                <div className="icon-list-text">
                    <h3>{title}</h3>
                    <p>{description}</p>
                </div>
            </div>
        </div>
    );
};

export default IconList;